import { useEffect } from 'react';
import { useClubModuleAccessStore } from '@/store/clubModuleAccess';

export function useClubModuleAccess() {
  const entitlements = useClubModuleAccessStore((s) => s.entitlements);
  const isLoading = useClubModuleAccessStore((s) => s.isLoading);
  const error = useClubModuleAccessStore((s) => s.error);
  const refresh = useClubModuleAccessStore((s) => s.refresh);

  useEffect(() => {
    if (entitlements === null && !isLoading) {
      void refresh();
    }
  }, [entitlements, isLoading, refresh]);

  return {
    entitlements,
    hasClubManagement: entitlements?.clubManagement ?? false,
    hasAcademyManagement: entitlements?.academyManagement ?? false,
    isLoading: isLoading || entitlements === null,
    error,
    refresh,
  };
}
